import type { FC, ReactNode } from "react";
import React from "react";
import cn from "classnames";
import styles from "./FunctionalButton.module.scss";

interface IFunctionalButtonContentProps {
  children: ReactNode;
  className?: string;
}

export const FunctionalButtonContent: FC<IFunctionalButtonContentProps> = ({
  children,
  className,
}) => {
  const getChildren = (chs: React.ReactNode): React.ReactNode => {
    return (
      <>
        {React.Children.toArray(chs).map((child, idx) => (
          <div
            key={`child-${idx}`}
            className={cn(styles.funcButtonContent__child)}
          >
            {child}
          </div>
        ))}
      </>
    );
  };
  return React.isValidElement(children) ? (
    React.cloneElement(children, {
      // TODO: review this typing
      // @ts-ignore
      className: cn(
        styles.funcButtonContent,
        children.props.className,
        className
      ),
      children: getChildren(children.props.children),
    })
  ) : (
    <div className={cn(styles.funcButtonContent, className)}>
      {getChildren(children)}
    </div>
  );
};
export default FunctionalButtonContent;
